import React, {Fragment} from 'react';
import {Button, Popup} from 'components';
import {flow, noop, redirect, useNamedSelector, useToggle} from 'helpers';
import {goals} from 'store';

export function PlanMyWeekContextMenu({id, Wrapper = Fragment}) {
  const {goal} = useNamedSelector('goals.details', {id, context: 'goals'});

  const deleteWeeklyObjective = (goal) => {
    goals.dispatch.remove(goal);
    redirect(`/today/plan-my-week/start`, true);
  };

  return Boolean(goal) && (
    <Wrapper>
      <Popup.Menu.Item icon={goal.status === 'Completed' ? 'undo' : 'check'} onClick={() => goals.dispatch.toggle(goal)}>
        {goal.status === 'Completed' ? 'Uncomplete' : 'Complete'}
      </Popup.Menu.Item>
      <Popup.Menu.Item icon="duplicate" onClick={flow(() => goals.dispatch.smartDuplicatePlanMyWeekObjective(goal, DuplicateMenu), redirect)}>
        Duplicate
      </Popup.Menu.Item>
      <Popup.Menu.Item icon="pencil" to={`/today/plan-my-week/weekly-objective/edit/${goal.id}/`}>
        Edit
      </Popup.Menu.Item>
      <Popup.Menu.DeleteItem onConfirm={() => deleteWeeklyObjective(goal)} />
    </Wrapper>
  );
}

function DuplicateMenu({id, popup}) {
  const {allActivities: activities, milestones} = useNamedSelector('goals.details', {id, context: 'goals'});
  const [includeMilestones, toggleMilestones] = useToggle(true);
  const [includeActivities, toggleActivities] = useToggle(true);
  return (
    <Popup.Menu onClick={noop}>
      <Popup.Menu.SubHeading>Duplicate with:</Popup.Menu.SubHeading>
      <Popup.Menu.Checkbox enabled={milestones.length > 0} checked={includeMilestones} onClick={toggleMilestones}>
        Milestones
      </Popup.Menu.Checkbox>
      <Popup.Menu.Checkbox enabled={activities.length > 0} checked={includeActivities} onClick={toggleActivities}>
        Activities
      </Popup.Menu.Checkbox>
      <Button
        className={['primary', 'filled']}
        onClick={flow(popup.close, () => goals.dispatch.duplicatePlanMyWeekObjective({
          id,
          milestones: includeMilestones ? milestones : [],
          activities: includeActivities ? activities : [],
        }))}
        children="Confirm"
      />
    </Popup.Menu>
  );
}
